import { SharedChartWidget } from '../shared/chart/SharedChartWidget';
import { useLeadVelocityAdapter } from './hooks/useAdminCharts';
import { WidgetConfig } from '../../infrastructure/contracts/widget.contract';

export const adminLeadVelocityConfig: WidgetConfig = {
  id: 'admin-lead-velocity',
  title: 'Lead Velocity',
  icon: 'show_chart',
  category: 'statistics',
  description: '14-Day Acquisition Trend',
  refreshStrategy: 'interval',
  defaultSize: { w: 4, h: 4 },
  priority: 2,
  supportedRoles: ['admin', 'superadmin']
};

export function AdminLeadVelocityWidget() {
  const dataQuery = useLeadVelocityAdapter();

  return (
    <SharedChartWidget
      config={adminLeadVelocityConfig}
      chartType="bar"
      dataQuery={dataQuery}
      emptyMessage="No lead data available for the last 14 days."
    />
  );
}
